module.exports = __webpack_public_path__ + "img/logo_sjm.2e166558.svg";